import React, { useEffect, useState, lazy } from 'react';
import { ShieldCheck, Eye } from 'lucide-react';
import { WhatsAppButton } from './WhatsAppButton';
import { useCurrency } from './CurrencyContext';
export function PremiumOfferSection() {
  const {
    currency,
    loading,
    formatPrice
  } = useCurrency();
  const [viewers, setViewers] = useState(70);
  useEffect(() => {
    const interval = setInterval(() => {
      setViewers(prev => {
        // Randomly go up 1-3, occasionally down 1, cap at 120
        const change = Math.random() > 0.2 ? Math.floor(Math.random() * 3) + 1 : -1;
        const next = prev + change;
        return Math.max(65, Math.min(next, 120));
      });
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <div id="first-10x1-product" className="mt-12 mb-6" data-id="element-171">
      <div className="bg-white rounded-3xl shadow-[0_4px_30px_rgba(0,0,0,0.06)] border border-[#EDE6D6] p-6 md:p-10 max-w-lg mx-auto" data-id="element-172">
        {/* Live Viewer Counter */}
        <div className="flex items-center justify-center gap-2 mb-5 bg-[#FFF8E1] border border-[#F7D060]/40 rounded-full px-4 py-2 max-w-xs mx-auto" data-id="element-173">
          <span className="relative flex h-2.5 w-2.5" data-id="element-174">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#D9A441] opacity-75" data-id="element-175"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#D9A441]" data-id="element-176"></span>
          </span>
          <Eye className="w-4 h-4 text-[#D9A441]" data-id="element-177" />
          <span className="text-sm font-bold text-gray-800" data-id="element-178">
            <span className="text-[#D9A441] font-black" data-id="element-179">{viewers}</span>{' '}
            personas viendo esta oferta
          </span>
        </div>

        {/* Product Image with Badge */}
        <div className="relative mx-auto mb-8 max-w-sm" data-id="element-180">
          <img src="https://cdn.magicpatterns.com/uploads/2HumLHhfW1WXgPEcvSgd57/ChatGPT_Image_10_abr_2026,_09_06_23_p.m..png" alt="Mi Aventura Sin Gluten - Chef Valeria Sartori - eBook" className="w-full rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.10)]" loading="lazy" data-id="element-181" />
          {/* OFERTA 10x1 Badge */}
          <div className="absolute top-3 right-3 bg-gradient-to-br from-[#F7D060] to-[#D9A441] text-gray-900 font-black text-xs md:text-sm px-3 py-1.5 rounded-lg shadow-md rotate-2" data-id="element-182">
            OFERTA 10x1
          </div>
        </div>

        {/* Product Title */}
        <h3 className="text-center md:text-[22px] text-gray-900 mb-6 px-2 font-[Roboto,_sans-serif] text-[24px] font-[800]" data-id="element-183">
          📘 Recetario Sin Gluten: 200+ Recetas Que Sí Funcionan
        </h3>

        {/* Price Section */}
        <div className="text-center mb-6" data-id="element-184">
          <div className="flex items-center justify-center gap-3 flex-wrap" data-id="element-185">
            {loading ? <span className="inline-block w-32 h-10 bg-gray-100 rounded-lg animate-pulse" data-id="element-186" /> : <>
                <span className="text-[20px] md:text-[24px] font-bold text-gray-400 line-through leading-none" data-id="element-187">
                  {formatPrice(115)}
                </span>
                <span className="text-[36px] md:text-[44px] font-black text-gray-900 leading-none" data-id="element-188">
                  {formatPrice(12.95)}
                  <span className="text-base font-bold text-gray-500 ml-1" data-id="element-189">
                    {currency.code}
                  </span>
                </span>
              </>}
            {/* 50% OFF Badge */}
            <span className="bg-red-500 text-white text-xs font-black px-2.5 py-1 rounded-md shadow-sm" data-id="element-190">
              50% OFF
            </span>
          </div>
        </div>

        {/* CTA Button */}
        <WhatsAppButton text="Sí, quiero mi pack ahora" href="YOUR_CHECKOUT_LINK_HERE" data-id="element-191" />

        {/* Urgency Badge */}
        <div className="flex justify-center mt-4" data-id="element-192">
          <span className="inline-flex items-center gap-1.5 bg-red-50 text-red-600 text-xs font-bold px-3 py-1.5 rounded-full border border-red-100" data-id="element-193">
            🔥 Últimos 5 cupos con regalo
          </span>
        </div>

        {/* Trust Text */}
        <div className="flex items-center justify-center gap-1.5 mt-4" data-id="element-194">
          <ShieldCheck className="w-4 h-4 text-gray-400" data-id="element-195" />
          <p className="text-gray-400 text-xs" data-id="element-196">Acceso inmediato vía PDF</p>
        </div>

        {/* Safe Checkout Badges */}
        <div className="mt-4 flex justify-center" data-id="element-197">
          <img src="https://cdn.magicpatterns.com/uploads/sw9mcsR5CMWLuQkfrosGaW/Trust-Badges-Secure-Checkout.png" alt="Métodos de pago seguros: Amex, Apple Pay, Discover, Google Pay, Mastercard, PayPal, Shop Pay, Venmo, Visa" className="max-w-[320px] w-full opacity-80" loading="lazy" data-id="element-198" />
        </div>
      </div>
    </div>;
}